import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  fetchSpecialityDetails,
  fetchSpecialityDoctors,
  fetchSpecialityBlogs,
  fetchSpecialityFAQ,
  fetchSpecialtyDetailsBanner,
  fetchPatientStoryVideos,
  fetchProceduresBySpecialityId,
} from "../Adapter/PageAdapter";
import { baseImage_path } from "../variables/Variables";
//import useSeo from "../hooks/useSeo";
//import SeoHelmet from "../components/SeoHelmet";
import useSeoWithParam from "../hooks/useSeoWithParam";
import SeoSpecialityHelmet from "../components/SeoSpecialityHelmet";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import leftArrow from "../assets/images/doc-detail/leftwrrw.svg";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import VideoTestimonials from "../components/VideoTestimonials";
import DoctorAppointmentModal from "../components/DoctorAppointmentModal";
import SpecialBan from "../assets/images/speci-detail/specdetailban.jpg";
import blkArrow from "../assets/images/spciallites/blkarw.svg";
import rightArrow from "../assets/images/right-arrow.svg";

const YOUTUBE_API_KEY = "AIzaSyCqtCNhyC9MIm1YeWy7eSlR6q1X3F-RoPw";

const SpecialitiesDetails = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [bannerData, setBannerData] = useState([]);
  const [speciality, setSpeciality] = useState(null);
  const [specialityId, setSpecialityId] = useState(null);
  const [activeTab, setActiveTab] = useState("overview");
  const [doctors, setDoctors] = useState([]);
  const [appointmentDoctor, setAppointmentDoctor] = useState(null);
  const [patientStories, setPatientStories] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [faq, setFaq] = useState([]);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [loading, setLoading] = useState(true);
  // const [videos, setVideos] = useState([]);
  const [playlistVideos, setPlaylistVideos] = useState([]);
  const [loadingVideos, setLoadingVideos] = useState(true);
  const [procedures, setProcedures] = useState([]);
  const sliderRef = useRef(null);

 // const seoData = useSeo(fetchSpecialityDetails);
 const seoData = useSeoWithParam(fetchSpecialityDetails, slug);

  const sanitizeSlug = (text) => {
    return text
      .toString()
      .replace(/\n/g, "")
      .toLowerCase()
      .trim()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-");
  };

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await fetchSpecialityDetails(sanitizeSlug(slug));
        console.log(response, "here is details spec slug");
        if (response && response.data) {
          setSpeciality(response.data);
          setSpecialityId(response.data.id);
        }
        if (response.data.video_link) {
          const videoUrl = response.data.video_link;
          const playlistId = videoUrl.match(/[?&]list=([a-zA-Z0-9_-]+)/)?.[1];

          if (playlistId) {
            const playlistVideos = await fetchPlaylistVideos(playlistId);
            if (playlistVideos.length > 0) {
              const playlistVideosWithId = playlistVideos.map((v) => ({
                ...v,
                playlistId,
              }));
              setPlaylistVideos(playlistVideosWithId);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching speciality details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [slug]);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        // const response = await fetchSpecialityDetails(slug);
        // if (response && response.data) {
        //   setSpeciality(response.data);
        //   setSpecialityId(response.data.id);
        // }

        // Specialty Banner
        const bannerResponse = await fetchSpecialtyDetailsBanner(specialityId);
        console.log("Banner Data", bannerResponse);
        if (bannerResponse && bannerResponse.data) {
          setBannerData(bannerResponse.data);
        }

        // Fetch doctors by speciality
        const doctorsResponse = await fetchSpecialityDoctors(specialityId);
        if (doctorsResponse && doctorsResponse.data) {
          setDoctors(doctorsResponse.data);
        }

        const storiesResponse = await fetchPatientStoryVideos();
        if (storiesResponse && storiesResponse.data) {
          setPatientStories(storiesResponse.data);
        }

        // Fetch FAQ data
        const faqResponse = await fetchSpecialityFAQ(specialityId); // Assuming the FAQ is related to the speciality ID
        if (faqResponse && faqResponse.data) {
          console.log("FAQ List ----", faqResponse);
          setFaq(faqResponse.data);
        }

        // Fetch Procedures
        const proceduresResponse = await fetchProceduresBySpecialityId(specialityId);
        if (proceduresResponse && proceduresResponse.status === "true") {
          setProcedures(proceduresResponse.data);
        }

        // Fetch All Blogs
        // const blogsResponse = await fetchAllBlogs();
        // if (blogsResponse && blogsResponse.data) {
        //   setBlogs(blogsResponse.data);
        // }
      } catch (error) {
        console.error("Error fetching speciality details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [specialityId]);

  // Our Blogs Section
  useEffect(() => {
    const fetchSpecialityBlogsData = async () => {
      try {
        const blogsResponse = await fetchSpecialityBlogs(specialityId); // Use the speciality ID
        if (blogsResponse && blogsResponse.data) {
          setBlogs(blogsResponse.data);
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    };

    fetchSpecialityBlogsData();
  }, [specialityId]);

  const handleOpenVideo = (url) => {
    setVideoUrl(url);
    setShowVideoModal(true);
  };
  const handleCloseVideo = () => {
    setShowVideoModal(false);
    setVideoUrl(null);

    // Manually remove Bootstrap modal-related classes
    document.body.classList.remove("modal-open");
    // Remove the modal backdrop if it exists
    const modalBackdrops = document.getElementsByClassName("modal-backdrop");
    while (modalBackdrops.length > 0) {
      modalBackdrops[0].parentNode.removeChild(modalBackdrops[0]);
    }
  };

  // Navigate to doctor details on "View Profile" click
  const handleViewProfile = (name) => {
    const formattedName = name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)+/g, "");
    window.scrollTo(0, 0);
    navigate(`/doctor/${formattedName}`);
  };

  // Handle Share Click
  const handleShare = (doctor) => {
    const doctorProfileUrl = `${window.location.origin}/doctor/${doctor.name}`;
    if (navigator.share) {
      navigator
        .share({
          title: `Check out Dr. ${doctor.name}`,
          text: `Learn more about Dr. ${doctor.name}, a specialist in ${doctor.speciality}.`,
          url: doctorProfileUrl,
        })
        .catch((error) => console.error("Error sharing:", error));
    } else {
      alert("Sharing is not supported in this browser.");
    }
  };

  const fetchPlaylistVideos = async (playlistId) => {
    console.log("Fetching videos for playlistId:", playlistId);

    try {
      const response = await fetch(
        `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=50&playlistId=${playlistId}&key=${YOUTUBE_API_KEY}`
      );

      const data = await response.json();
      console.log("Fetched Playlist Data:", data);

      if (data.items && data.items.length > 0) {
        return data.items.map((item) => ({
          title: item.snippet.title,
          videoId: item.snippet.resourceId.videoId,
          thumbnailUrl: `https://img.youtube.com/vi/${item.snippet.resourceId.videoId}/hqdefault.jpg`,
          videoUrl: `https://www.youtube.com/watch?v=${item.snippet.resourceId.videoId}`,
        }));
      }

      return [];
    } catch (error) {
      console.error("Error fetching playlist videos:", error);
      return [];
    }
  };

  const handleVideoThumbnails = async (videosList) => {
    let updatedVideos = [];
    let updatedPlaylistVideos = [];

    for (const video of videosList) {
      if (video.thumbnail_img) {
        updatedVideos.push({
          ...video,
          thumbnailUrl: `${baseImage_path}${video.thumbnail_img}`,
          videoUrl: video.video_url,
        });
      } else if (video.video_url.includes("playlist")) {
        console.log("Fetching Playlist Videos for URL:", video.video_url);
        const playlistId = video.video_url.match(
          /[?&]list=([a-zA-Z0-9_-]+)/
        )?.[1];

        if (playlistId) {
          const playlistVideos = await fetchPlaylistVideos(playlistId);
          if (playlistVideos.length > 0) {
            const playlistVideosWithId = playlistVideos.map((v) => ({
              ...v,
              playlistId, // capture it once for View All button
            }));
            updatedPlaylistVideos = [
              ...updatedPlaylistVideos,
              ...playlistVideosWithId,
            ];
          }
        }
      } else {
        const videoId = video.video_url.match(/[?&]v=([^&]+)/)?.[1];
        const youtubeThumbnail = videoId
          ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
          : null;

        updatedVideos.push({
          ...video,
          thumbnailUrl: youtubeThumbnail || "default-thumbnail.jpg",
          videoUrl: video.video_url,
        });
      }
    }

    console.log("Final Individual Videos List:", updatedVideos);
    console.log("Final Playlist Videos List:", updatedPlaylistVideos);

    // setVideos(updatedVideos); // Only update individual videos
    setPlaylistVideos(updatedPlaylistVideos); // Only update playlist videos
    setLoadingVideos(false);
  };

  // Slide Handler
  const handleSlide = (direction) => {
    if (sliderRef.current) {
      const scrollAmount = 300; // Adjust based on your slide width
      if (direction === "left") {
        sliderRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      } else if (direction === "right") {
        sliderRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    }
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!speciality) {
    return <p>Speciality not found.</p>;
  }

  return (
    <>
      {seoData && <SeoSpecialityHelmet data={seoData} />}
      {/* Banner Section */}
      <section className="banner-spac">
        <div className="cust-container">
          <div className="banner-box">
            {bannerData && bannerData.banner_img ? (
              <img
                src={`${baseImage_path}${bannerData.banner_img.replace(
                  /^\.\//,
                  ""
                )}`}
                alt={bannerData.banner_heading || "Specialty"}
              />
            ) : (
              <img src={SpecialBan} alt="Specialty Fallback" />
            )}
            <div className="ban-con">
              <h1>{speciality.name}</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation Section */}
      {/* <section className="special-detail-target-sec mrgntop70">
        <div className="cust-container">
          <div className="special-detail-target-inner">
            <ul>
              <li style={{ cursor: "pointer" }}>
                <a className={activeTab === "overview" ? "active" : ""} onClick={() => setActiveTab("overview")}>Overview</a>
              </li>
              <li style={{ cursor: "pointer" }}>
                <a className={activeTab === "disease" ? "active" : ""} onClick={() => setActiveTab("disease")}>Disease</a>
              </li>
              <li style={{ cursor: "pointer" }}>
                <a className={activeTab === "treatment" ? "active" : ""} onClick={() => setActiveTab("treatment")}>Treatment</a>
              </li>
              <li style={{ cursor: "pointer" }}>
                <a className={activeTab === "procedure" ? "active" : ""} onClick={() => setActiveTab("procedure")}>Procedure</a>
              </li>
              <li style={{ cursor: "pointer" }}>
                <a className={activeTab === "technology" ? "active" : ""} onClick={() => setActiveTab("technology")}>Technology</a>
              </li>
              <li style={{ cursor: "pointer" }}>
                <a href="#expert-cardiologistid">Doctors</a>
              </li>
              <li>
                <a href="#ourvideosid">Videos</a>
              </li>
              <li>
                <a href="#ourblogs">Blogs</a>
              </li>
              <li>
                <a href="#patientstoriesid">Patient Stories</a>
              </li>
              <li>
                <a href="#faqid">FAQ</a>
              </li>
            </ul>
          </div>
        </div>
      </section> */}
      <section className="special-detail-target-sec mrgntop70">
        <div className="cust-container">
          <div className="special-detail-target-inner">
            <ul>
              {speciality.overview && (
                <li style={{ cursor: "pointer" }}>
                  <a
                    className={activeTab === "overview" ? "active" : ""}
                    onClick={() => setActiveTab("overview")}
                  >
                    Overview
                  </a>
                </li>
              )}
              {speciality.disease && (
                <li style={{ cursor: "pointer" }}>
                  <a
                    className={activeTab === "disease" ? "active" : ""}
                    onClick={() => setActiveTab("disease")}
                  >
                    Disease
                  </a>
                </li>
              )}
              {speciality.treatment && (
                <li style={{ cursor: "pointer" }}>
                  <a
                    className={activeTab === "treatment" ? "active" : ""}
                    onClick={() => setActiveTab("treatment")}
                  >
                    Treatment
                  </a>
                </li>
              )}
              {(speciality.procedure || procedures.length > 0) && (
                <li style={{ cursor: "pointer" }}>
                  {procedures.length > 0 ? (
                    <a href="#procedure-section">Procedure</a>
                  ) : (
                    <a
                      className={activeTab === "procedure" ? "active" : ""}
                      onClick={() => setActiveTab("procedure")}
                    >
                      Procedure
                    </a>
                  )}
                </li>
              )}
              {speciality.technology && (
                <li style={{ cursor: "pointer" }}>
                  <a
                    className={activeTab === "technology" ? "active" : ""}
                    onClick={() => setActiveTab("technology")}
                  >
                    Technology
                  </a>
                </li>
              )}
              {doctors.length > 0 && (
                <li style={{ cursor: "pointer" }}>
                  <a href="#expert-cardiologistid">Doctors</a>
                </li>
              )}
              {/* {(videos.length > 0 || playlistVideos.length > 0) && ( */}
              {playlistVideos.length > 0 && (
                <li style={{ cursor: "pointer" }}>
                  <a href="#ourvideosid">Videos</a>
                </li>
              )}
              {blogs.length > 0 && (
                <li style={{ cursor: "pointer" }}>
                  <a href="#ourblogs">Blogs</a>
                </li>
              )}
              {patientStories.length > 0 && (
                <li style={{ cursor: "pointer" }}>
                  <a href="#patientstoriesid">Patient Stories</a>
                </li>
              )}
              {faq.length > 0 && (
                <li style={{ cursor: "pointer" }}>
                  <a href="#faqid">FAQ</a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </section>

      {/* Overview Section */}
      {/* <section className="overview-sec mrgntop70" id="overviewid">
        <div className="cust-container">
          <div className="finnest host-det">
            <h4>Overview</h4>
            <p dangerouslySetInnerHTML={{
              __html: speciality.overview || "No description available.",
            }} />
          </div>
        </div>
      </section> */}

      {/* Diseases Section */}
      {/* <section className="overview-sec mrgntop70" id="diseasesid">
        <div className="cust-container">
          <div className="finnest host-det">
            <h4>Diseases</h4>
            <p dangerouslySetInnerHTML={{
              __html: speciality.disease || "No Diseases details available.",
            }} />
          </div>
        </div>
      </section> */}

      {/* Treatment Section */}
      {/* {speciality.treatment && (
        <section className="overview-sec mrgntop70" id="treatmentid">
          <div className="cust-container">
            <div className="finnest host-det">
              <h4>Treatment</h4>
              <p dangerouslySetInnerHTML={{ __html: speciality.treatment }} />
            </div>
          </div>
        </section>
      )} */}

      {/* Procedure Section */}
      {/* {speciality.procedure && (
        <section className="overview-sec mrgntop70" id="procedureid">
          <div className="cust-container">
            <div className="finnest host-det">
              <h4>Procedure</h4>
              <p dangerouslySetInnerHTML={{ __html: speciality.procedure }} />
            </div>
          </div>
        </section>
      )} */}

      {/* Technology Section */}
      {/* {speciality.technology && (
        <section className="overview-sec mrgntop70" id="technologyid">
          <div className="cust-container">
            <div className="finnest host-det">
              <h4>Technology</h4>
              <p dangerouslySetInnerHTML={{ __html: speciality.technology }} />
            </div>
          </div>
        </section>
      )} */}

      <section className="overview-sec mrgntop70" id="overviewid">
        <div className="cust-container">
          <div className="host-det specialDetailPad">
            {activeTab === "overview" && (
              <>
                <h4>Overview</h4>
                <div className="ck-content"
                  dangerouslySetInnerHTML={{
                    __html: speciality.overview || "No description available.",
                  }}
                />
              </>
            )}
            {activeTab === "disease" && (
              <>
                <h4>Disease</h4>
                <div className="ck-content"
                  dangerouslySetInnerHTML={{
                    __html:
                      speciality.disease || "No disease details available.",
                  }}
                />
              </>
            )}
            {activeTab === "treatment" && (
              <>
                <h4>Treatment</h4>
                <div className="ck-content"
                  dangerouslySetInnerHTML={{
                    __html:
                      speciality.treatment || "No treatment details available.",
                  }}
                />
              </>
            )}
            {activeTab === "technology" && (
              <>
                <h4>Technology</h4>
                <div className="ck-content"
                  dangerouslySetInnerHTML={{
                    __html:
                      speciality.technology ||
                      "No technology details available.",
                  }}
                />
              </>
            )}
            {activeTab === "procedure" && procedures.length === 0 && (
              <>
                <h4>Procedure</h4>
                <div className="ck-content"
                  dangerouslySetInnerHTML={{
                    __html:
                      speciality.procedure ||
                      "No procedure details available.",
                  }}
                />
              </>
            )}
          </div>
        </div>
      </section>

      {/* Procedure Section */}
      {procedures.length > 0 && (
        <section className="procedure-sec-main mrgntop70" id="procedure-section">
          <div className="cust-container">
            <div className="finnest host-det text-center margin-botom40">
              <h4>Our Procedures</h4>
            </div>

            <div className="procedure-slider-container">
              <Swiper
                modules={[Navigation, Autoplay]}
                navigation={{
                  nextEl: ".procedure-swiper-next-spec",
                  prevEl: ".procedure-swiper-prev-spec",
                }}
                slidesPerView={3}
                spaceBetween={30}
                loop={procedures.length > 3}
                autoplay={{
                  delay: 4000,
                  disableOnInteraction: false,
                }}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                }}
              >
                {procedures.map((item) => (
                  <SwiperSlide key={item.id}>
                    <div
                      className="card procedure-card-item h-100 shadow-sm border-0"
                      style={{
                        cursor: "pointer",
                        borderRadius: "15px",
                        overflow: "hidden",
                      }}
                      onClick={() =>
                        navigate(`/specialities/${slug}/procedure/${item.slug}`)
                      }
                    >
                      <div
                        className="procedure-img-wrapper"
                        style={{ height: "200px", overflow: "hidden" }}
                      >
                        <img
                          src={
                            item.img_path
                              ? `${baseImage_path}/${item.img_path.replace(
                                  /^\.\//,
                                  ""
                                )}`
                              : "https://via.placeholder.com/400x250"
                          }
                          className="card-img-top h-100 w-100"
                          style={{
                            objectFit: "cover",
                            transition: "transform 0.3s ease",
                          }}
                          alt={item.name}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.transform = "scale(1.1)")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                        />
                      </div>
                      <div className="card-body text-center p-3">
                        <h5
                          className="card-title mb-0"
                          style={{
                            color: "#003366",
                            fontWeight: "500",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            minHeight: "2.4em", // Ensures consistent height for 1 or 2 lines
                            lineHeight: "1.2em"
                          }}
                        >
                          {item.name}
                        </h5>
                        <div className="mt-2">
                          <span
                            style={{
                              color: "#0ca84f",
                              fontSize: "0.9rem",
                              fontWeight: "500",
                            }}
                          >
                            View Details{" "}
                            <img
                              src={blkArrow}
                              alt="arrow"
                              style={{ width: "12px", marginLeft: "5px" }}
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              
              {/* Navigation Arrows */}
              <div className="procedure-slider-nav-Spec">
                <span className="procedure-swiper-prev-spec">
                  <img src={leftArrow} alt="Previous" />
                </span>
                <span className="procedure-swiper-next-spec">
                  <img
                    src={leftArrow}
                    alt="Next"
                    style={{ transform: "rotate(180deg)" }}
                  />
                </span>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Our Expert Dotors Section */}
      {doctors.length > 0 && (
        <section
          className="our-expert-cardiologist-sec mrgntop70 margnbot90"
          id="expert-cardiologistid"
        >
          <div className="cust-container">
            {appointmentDoctor && (
              <DoctorAppointmentModal doctor={appointmentDoctor} onClose={() => setAppointmentDoctor(null)} />
            )}
            <div className="finnest host-det text-center margin-botom40">
              <h4>Our Team of Experts</h4>
            </div>
            <div className="row">
              {doctors.length > 0 ? (
                doctors.map((doctor) => (
                  <div
                    key={doctor.id}
                    className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4"
                  >
                    <div
                      className="oueextpert-cardiolo-item"
                      onClick={() => handleViewProfile(doctor.slug)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="cardiolo-item-img">
                        <img
                          src={
                            doctor.img_path
                              ? `${baseImage_path}/${doctor.img_path.replace(
                                /^\./,
                                ""
                              )}`
                              : `${baseImage_path}/images/default-doctor.png`
                          }
                          alt={doctor.name}
                        />
                      </div>
                      <div className="cardiolo-itemdesc">
                        <div className="drs-design">
                          <span>{doctor.speciality_name}</span>
                          <button
                            style={{
                              background: "transparent",
                              color: "#0ca854",
                              fontSize: "12px",
                              fontWeight: "500",
                            }}
                          >
                            View Profile
                          </button>
                        </div>
                        <div className="drs-title">
                          <h4>{doctor.name_prefix} {doctor.name}</h4>
                        </div>
                        <p>
                          {/* {doctor.experience
                            ? `Total Experience - ${doctor.experience} yrs`
                            : "Experience not available"} */}
                          Total Experience - {doctor.experience ? doctor.experience.replace(/\+/g, '') + '+' : 'N/A'} Years
                        </p>
                        <div className="drs-bookapp-cta common-roundcta">
                          <button
                            className="btnhv"
                            onClick={(e) => {
                              e.stopPropagation();
                              setAppointmentDoctor({ id: doctor.id, name: doctor.name, specialityId: specialityId, specialityName: doctor.speciality_name });
                            }}
                          >
                            Book Appointment
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p style={{ textAlign: "center" }}>
                  No doctors available for this specialty.
                </p>
              )}
            </div>
          </div>
        </section>
      )}

      {/* Videos Section Playlist */}
      {playlistVideos.length > 0 && (
        <section
          className="our-video-sec mrgntop70 margnbot90 spaceVideo"
          id="ourvideosid"
        >
          <div className="cust-container">
            <div className="finnest host-det text-center margin-botom40">
              <h4>Videos</h4>
            </div>
            <div className="video-slider-container">
              <Swiper
                modules={[Navigation, Autoplay]}
                spaceBetween={20}
                slidesPerView={1}
                loop={true}
                navigation={{
                  nextEl: ".video-swiper-next-spec",
                  prevEl: ".video-swiper-prev-spec",
                }}
                onInit={(swiper) => {
                  swiper.navigation.init();
                  swiper.navigation.update();
                }}
                autoplay={{
                  delay: 8000,
                  disableOnInteraction: false,
                }}
                breakpoints={{
                  640: { slidesPerView: 1 },
                  1024: { slidesPerView: 2 },
                  1280: { slidesPerView: 3 },
                }}
              >
                {[...playlistVideos].map((video, index) => (
                  <SwiperSlide key={index}>
                    <div className="our-video-sec-item DoctorsSpeciPage">
                      <div className="our-video-img">
                        <img
                          src={video.thumbnailUrl || "default-thumbnail.jpg"}
                          alt={video.title || "Video"}
                          style={{
                            width: "100%",
                            height: "200px",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                      <div className="our-video-desc">
                        <h4>{video.title || "Video Title"}</h4>
                        <a
                          href={video.videoUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Watch now <img src={blkArrow} alt="Arrow" />
                        </a>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              {/* Navigation Arrows */}
              <div className="video-slider-nav-Spec">
                <span className="video-swiper-prev-spec">
                  <img src={leftArrow} alt="Previous" />
                </span>
                <span className="video-swiper-next-spec">
                  <img
                    src={leftArrow}
                    alt="Next"
                    style={{ transform: "rotate(180deg)" }}
                  />
                </span>
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              {playlistVideos.length > 0 && playlistVideos[0].playlistId && (
                <a
                  className="btn btn-primary"
                  href={`https://www.youtube.com/playlist?list=${playlistVideos[0].playlistId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View All
                </a>
              )}
            </div>
          </div>
        </section>
      )}

      {/* Our Blogs Section */}
      {blogs.length > 0 && (
        <section className="our-blogs-sec mrgntop70 margnbot90" id="ourblogs">
          <div className="cust-container">
            <div className="finnest host-det text-center margin-botom40">
              <h4>Our Blogs</h4>
            </div>

            {blogs.length > 0 ? (
              <div className="blog-slider-container">
                <div className="custom-swiper-prev">
                  <img src={leftArrow} alt="Previous" />
                </div>
                <Swiper
                  modules={[Navigation, Autoplay]}
                  navigation={{
                    nextEl: ".custom-swiper-next",
                    prevEl: ".custom-swiper-prev",
                  }}
                  slidesPerView={3}
                  spaceBetween={30}
                  loop={true}
                  autoplay={{
                    delay: 4000,
                    disableOnInteraction: false,
                  }}
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                  }}
                >
                  {blogs.map((blog) => (
                    <SwiperSlide key={blog.id}>
                      <div className="our-video-sec-item">
                        <div className="our-video-img">
                          <img
                            src={
                              blog.featured_img
                                ? `${baseImage_path}/${blog.featured_img}`
                                : "default-blog.jpg"
                            }
                            alt={blog.title}
                          />
                          <div className="our-vdo-categ">
                            <span>{blog.category || "Uncategorized"}</span>
                          </div>
                          <div className="our-video-desc our-vdo-desc-cta-green">
                            <span>
                              {new Date(blog.created_at).toLocaleDateString(
                                "en-US",
                                {
                                  month: "short",
                                  day: "2-digit",
                                  year: "numeric",
                                }
                              )}
                            </span>
                            <p>{blog.title}</p>
                            <a href={`/blogs/${blog.slug}`}>Read More</a>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
                <div className="custom-swiper-next">
                  <img src={rightArrow} alt="Next" />
                </div>
              </div>
            ) : (
              <div className="no-blogs">
                No Blogs Available for this Specialty.
              </div>
            )}
          </div>
        </section>
      )}

      {/* Expert Insights */}
      <section
        className="patient-story-sec mrgntop70 margnbot90"
        id="patientstoriesid"
      >
        <div className="cust-container">
          <div className="finnest host-det text-center margin-botom40">
            <h4>Patient Stories</h4>
          </div>
          <VideoTestimonials />
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-sec margnbot90" id="faqid">
        <div className="cust-container">
          <div className="finnest host-det text-center margin-botom40">
            <h4>FAQ</h4>
          </div>
          <div className="faqsec-inner">
            <div className="accordion" id="special-detail-faqs">
              {faq.length > 0 ? (
                faq.map((item, index) => (
                  <div className="card" key={item.id}>
                    <div className="card-header" id={`heading${item.id}`}>
                      <button
                        className="collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target={`#collapse${item.id}`}
                        aria-expanded="false"
                        aria-controls={`collapse${item.id}`}
                      >
                        {item.question}
                      </button>
                    </div>
                    <div
                      id={`collapse${item.id}`}
                      className="collapse"
                      aria-labelledby={`heading${item.id}`}
                      data-parent="#special-detail-faqs"
                    >
                      <div className="card-body">
                        {/* <p>{item.answer}</p> */}
                        <p dangerouslySetInnerHTML={{ __html: item.answer }} />
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No FAQs available for this specialty.</p>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Modal for patient video */}
      {showVideoModal && (
        <div
          className="modal fade custmodal-width show"
          style={{ display: "block" }}
          id="patientvdo"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modalclosebtn">
                <button
                  type="button"
                  className="close"
                  onClick={handleCloseVideo}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                {videoUrl && (
                  <iframe
                    src={videoUrl}
                    title="Video Player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SpecialitiesDetails;
